// extracted by mini-css-extract-plugin
export var aboveInput = "_k0-0";
export var actionButton = "_k0-5";
export var actionButtonContainer = "_k0-1";
export var actionIcon = "_k0-6";
export var aiInfoContainer = "_k0-2";
export var attachmentWrapper = "_k0-7";
export var bold = "_k0-3";
export var checkIcon = "_k0-8";
export var clickingRecipientBar = "_k0-11";
export var commentThreadSwitch = "_k0-a";
export var draftImage = "_k0-b";
export var draftImageContainer = "_k0-c";
export var draftImages = "_k0-e";
export var editButton = "_k0-g";
export var editor = "_k0-f";
export var editorContainer = "_k0-y";
export var editorErrorTooltipWrapper = "_k0-9";
export var headerDivider = "_k0-h";
export var icon = "_k0-i";
export var info = "_k0-j";
export var internal = "_k0-n";
export var internalDivider = "_k0-k";
export var internalMessage = "_k0-l";
export var messageInputCard = "_k0-m";
export var messageInputForm = "_k0-o";
export var messageInputFormInternal = "_k0-p";
export var options = "_k0-q";
export var publicMessageCustomer = "_k0-s";
export var publicMessageMerchant = "_k0-r";
export var removeImageButton = "_k0-d";
export var replyButtons = "_k0-t";
export var showSignatureButton = "_k0-u";
export var spinner = "_k0-v";
export var verticalButtonDivider = "_k0-4";
export var visibilitySelector = "_k0-w";
export var warning = "_k0-x";
export var wrappingText = "_k0-z";
export var writingInternalNoteTopBorder = "_k0-10";